<template>
	<MainContent />
</template>

<script>
export default {
	name: 'IndexPage',
};
</script>
